import { useEffect } from 'react'

export default function EnvironmentBanner() {
    const env = import.meta.env.VITE_ENVIRONMENT
    const isVisible = !!env && env !== 'prod'

    // Expose banner height as a CSS variable so fixed-positioned regions
    // (e.g. the mobile chat container) can offset themselves below it.
    useEffect(() => {
        const root = document.documentElement
        if (isVisible) {
            root.style.setProperty('--env-banner-height', '24px')
        } else {
            root.style.setProperty('--env-banner-height', '0px')
        }
    }, [isVisible])

    if (!isVisible) return null

    return (
        <div className='bg-amber-500 text-white text-center text-xs font-semibold py-1 sticky top-0 z-[60]'>
            DEVELOPMENT ENVIRONMENT (Data may be reset at any time)
        </div>
    )
}
